import { configureStore } from '@reduxjs/toolkit'
import NavigationReducer from '../navigation/ducks/navigationSlice'

const store = configureStore({
  reducer: {
    navigation: NavigationReducer,
  },
})

export default store
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch